import * as actionTypes from '../action-types';
import { AggregationsType } from '../../search.types';
import {
  SearchActions,
  QueryParamsActions,
  AggregationsActions,
} from '../actions';

export const defaultState: AggregationsType = {
  domaine: [],
  juridiction: [],
  publi: [],
  solution: [],
  dates: [],
  ville: [],
  parties: [],
  exclude: [],
  publisher: [],
  textCode: [],
  collectiveAgreements: [],
  otherLegislation: [],
  commentaryAccess: [],
};

export function aggregationsReducer(
  state: AggregationsType = defaultState,
  action: SearchActions | QueryParamsActions | AggregationsActions,
) {
  switch (action.type) {
    case actionTypes.SYNC_QUERY_RESPONSE: {
      const { aggregations } = action.payload.response;
      return { ...aggregations };
    }
    case actionTypes.SYNC_AGGREGATIONS: {
      const { aggregations } = action.payload;
      return { ...aggregations };
    }
    case actionTypes.UPDATE_TYPE: {
      return { ...defaultState };
    }
    default:
      return state;
  }
}
